import { defineMessages } from 'react-intl';

export default defineMessages({
  emptyEmailError: {
    id: 'LoginForm.emptyEmailError',
    description: 'Login Form empty email error message',
    defaultMessage: 'Enter valid email address. Field cannot be blank.',
  },
  emailFormatError: {
    id: 'LoginForm.emailFormatError',
    description: 'Login Form invalid email address format error message',
    defaultMessage: 'Enter valid email address.',
  },
  emptyPasswordError: {
    id: 'LoginForm.emptyPasswordError',
    description: 'Login Form empty password error message',
    defaultMessage: 'Enter password. Field cannot be blank.',
  },
  emailLabel: {
    id: 'LoginForm.emailLabel',
    description: 'Login Form email field label',
    defaultMessage: 'Email',
  },
  passwordLabel: {
    id: 'LoginForm.passwordLabel',
    description: 'Login Form password field label',
    defaultMessage: 'Password',
  },
  rememberMeLabel: {
    id: 'LoginForm.rememberMeLabel',
    description: 'Login Form remember me field label',
    defaultMessage: 'Remember Me',
  },
  forgotPasswordLink: {
    id: 'LoginForm.forgotPasswordLink',
    description: 'Login Form forgot password link text',
    defaultMessage: 'Forgot Password?',
  },
  signInButton: {
    id: 'LoginForm.signInButton',
    description: 'Login Form sign in button text',
    defaultMessage: 'Sign In',
  },
});
